import styled from '@emotion/styled';
import { colors, Stack } from '@ui-components/neo.tax';

export const StyledContainerStack = styled(Stack)({
  border: '1px solid',
  borderColor: colors.gray[200],
  backgroundColor: colors.gray[100],
  borderRadius: '0 0 6px 6px',
  boxShadow: 'inset 0 1px 0px rgba(0, 0, 0, 0.05)', // Inner shadow
});

export const StyledCardStack = styled(Stack)({
  border: '1px solid',
  borderColor: colors.gray[200],
  backgroundColor: colors.white,
  borderRadius: '6px',
});
